import React, { useEffect, useState } from 'react'
import "./ReplyMessage.css"
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { IoLogOut, IoPerson, IoPersonOutline } from 'react-icons/io5';
import { FaHome, FaQuestionCircle } from 'react-icons/fa';
import { useLocation } from "react-router-dom";
import { TiArrowBack } from 'react-icons/ti';
import Sidebar2 from '../Sidebar/Sidebar2';
import { IoMdArrowDropdownCircle, IoMdMenu } from 'react-icons/io';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { MdOutlineEmail } from 'react-icons/md';

const ReplyMessage = () => {
    const Icon = ({ name, className = "w-6 h-6" }) => {
        const icons = {
            'credit-card': <><path d="M2 9a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9Z" /><path d="M2 14h20" /></>,
            'user': <><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></>,
            'lock': <><rect width="18" height="11" x="3" y="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></>,
            'link': <><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.72" /><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.72-1.72" /></>,
            'inbox': <><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></>,
            'users': <><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M22 21v-2a4 4 0 0 0-3-3.87" /><path d="M16 3.13a4 4 0 0 1 0 7.75" /></>,
            'mail': <><rect width="20" height="16" x="2" y="4" rx="2" /><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" /></>,
            'pen-square': <><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /></>,
            'help-circle': <><circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><path d="M12 17h.01" /></>,
            'thumbs-up': <><path d="M7 10v12" /><path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a2 2 0 0 1 1.01.27Z" /></>,
            'message-square': <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />,
            'book-open': <><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" /><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" /></>,
            'menu': <><line x1="4" x2="20" y1="12" y2="12" /><line x1="4" x2="20" y1="6" y2="6" /><line x1="4" x2="20" y1="18" y2="18" /></>,
            'chevron-down': <path d="m6 9 6 6 6-6" />,
            'x': <><path d="M18 6 6 18" /><path d="m6 6 12 12" /></>,
            'plus': <><path d="M5 12h14" /><path d="M12 5v14" /></>,
        };

        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
                {icons[name]}
            </svg>
        );
    };




    // Mock data - in a real app, this would come from an API


    // State for the message body
    const [messageBody, setMessageBody] = useState('');
    const [message, setMessage] = useState("")

    // State for the include signature checkbox
    const [includeSignature, setIncludeSignature] = useState(false);

    // State for the selected template
    const [selectedTemplate, setSelectedTemplate] = useState('');

    // State for the modal
    const [showModal, setShowModal] = useState(false);
    const [modalMessage, setModalMessage] = useState('');

    // Mock data for recipients and templates
    const recipients = [
        { id: 1, name: 'John Doe', email: 'john@example.com' },
        { id: 2, name: 'Jane Smith', email: 'jane@example.com' },
        { id: 3, name: 'Bob Johnson', email: 'bob@example.com' }
    ];

    const templates = [
        { id: 1, name: 'Follow-up', content: 'Hi [Name],\n\nI hope this message finds you well.\n\n[Your message here]\n\nBest regards,' },
        { id: 2, name: 'Thank You', content: 'Dear [Name],\n\nThank you for your message. We appreciate your time and effort.\n\nBest regards,' },
        { id: 3, name: 'Reminder', content: 'Hi [Name],\n\nThis is a friendly reminder about [topic].\n\nPlease let me know if you have any questions.\n\nBest regards,' }
    ];

    // Mock data for previous messages
    const previousMessages = [
        { id: 1, subject: 'Project Update', date: '2023-05-15', sender: 'Team Lead' },
        { id: 2, subject: 'Meeting Reminder', date: '2023-05-10', sender: 'HR Department' },
        { id: 3, subject: 'Document Review', date: '2023-05-05', sender: 'Project Manager' }
    ];

    // Function to handle template selection
    const cleanHTML = (html) => {
        if (!html) return "";
        return html.replace(/<[^>]+>/g, ""); // removes all HTML tags
    };
    const handleTemplateChange = (e) => {
        const templateId = parseInt(e.target.value);
        const template = template1.find(t => t.id === templateId);

        if (!template) return;

        // ONLY set template body
        setMessageBody(template.email_body || "");
        setSelectedTemplate1(template.email_body || "")
        setSelectedTemplate(templateId);
    };


    // Function to simulate sending a message


    // Function to simulate canceling
    const simulateCancel = () => {
        setMessageBody('');
        setSelectedTemplate('');
        setModalMessage('Message draft cleared.');
        setShowModal(true);
        navigate("/dashboard")
    };

    // Function to simulate creating a new template
    const simulateCreateTemplate = () => {
        setModalMessage('Template creation feature would be implemented here.');
        setShowModal(true);
    };

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
    };

    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [imagePreview, setImagePreview] = useState("");
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [emailsig, setEmailSig] = useState("")
    const [subtitle, setSubtitle] = useState("")
    const [Heading, setHeading] = useState("")
    const [user2, setUser2] = useState("")
    const fetchProfile = async () => {
        try {
            const token = sessionStorage.getItem("authToken");
            const response = await axios.get("https://tracsdev.apttechsol.com/api/my-profile", {
                headers: { Authorization: `Bearer ${token}` },
            });

            const data = response.data;

            setName(data.user.name || "");
            setPhone(data.user.phone || "");
            setEmailSig(data.user.email || "")
            setSubtitle(data.helpnote?.find(item => item.id === 13)?.title || "")
            setHeading(data.helpnote.find(item => item.id === 13)?.page_url);
            setImagePreview(`https://tracsdev.apttechsol.com/public/${data.user.image}`);
            console.log("user2:", response.data.user?.id)
            setUser2(response.data.user?.id)
        } catch (error) {
            console.error("Error fetching profile data:", error);
        }
    };
    useEffect(() => {
        fetchProfile();
    }, []);
    const { subject, user_id, replies_code } = useParams();
    const [data, setData] = useState("");
    const [sentMail, setSentMails] = useState([]);
    const [signature, setSignature] = useState('');
    const [template1, setTemplate1] = useState([])
    const [recivesmails, setrecivedmails] = useState([]);
    const [selectedTemplateId] = useState(null);
    const [showad, setShowad] = useState(false);
    const [key, setKey] = useState("")
    const [subject2, setSubject] = useState("");
    const [userId, setUserId] = useState("");
    const [selectedTemplate1, setSelectedTemplate1] = useState("")
    useEffect(() => {
        const fetchData = async () => {
            const token = sessionStorage.getItem("authToken");
            try {
                const response = await axios.get(
                    `https://tracsdev.apttechsol.com/api/view_user_inboxhistory_intro/${subject}/${user_id}/${replies_code}`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                setData(response.data);
                setSentMails(response.data.sentMails?.data || []);
                setrecivedmails()
                setKey(response.data.keyfields?.find(item => item.id === 4)?.description)
                setSignature(response.data.authsignature?.name);
                setTemplate1(response.data.normal_email_templates)
                setSubject(response.data.sentMailsfirst?.subject)
                setUserId(response.data.userInfo?.id)
                console.log("subject", response.data.sentMailsfirst?.subject)
                console.log("userId", response.data.userInfo?.id)

            } catch (err) {
                console.error("Error fetching inbox history:", err);
            }
        };
        fetchData();
    }, [subject, user_id, replies_code]);


    useEffect(() => {
        if (data.usersData && data.usersData.length > 0) {
            // collect all recipient emails
            const emails = data.usersData.map(user => user.email);
            setSelectedRecipientEmails(emails);
        }
    }, [data.usersData]);



    const [selectedRecipientEmails, setSelectedRecipientEmails] = useState([]);

    const payload = {
        user_id: data.userInfo?.id,
        sent_mail_history_id: data.sentMailsfirst?.id,
        replies_code,
        temp_id: selectedTemplateId,
        subject: data.sentMailsfirst?.subject,
        selected_emails: selectedRecipientEmails,
        redirect_to: "https://tracsdev.apttechsol.com/user/view-inbox-list-from-intro",
        is_bump: data.sentMailsfirst?.is_bump,
        cc_mail_id: null,
        emails: selectedRecipientEmails,
        email_template: selectedTemplate,
        message: messageBody,
        files: null
    };
    console.log("payload :", payload)
    const handleSendReply = async () => {
        const token = sessionStorage.getItem("authToken");
        try {

            if (!selectedRecipientEmails || selectedRecipientEmails.length === 0) {
                alert("Please select at least one recipient email before sending.");
                return; // ⛔ stop execution
            }
            const response = await axios.post(
                `https://tracsdev.apttechsol.com/api/sendReplyMailtomem_Api`,
                payload,
                { headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" } }
            );
            console.log("Mail Sent Successfully", response.data);
            alert("Mail Sent Successfully", response.data);
            console.log("payload", payload)

        } catch (error) {
            console.error("Error sending reply mail:",
                error.response?.data?.message || error.message
            );
            alert(error.response?.data?.message || error.message)
        }

    };
    const [Heasderdropdown, setHeaderdropdown] = useState(null);
    const showDropDown = () => {
        setHeaderdropdown(prev => !prev)
    }
    const navigate = useNavigate();
    const handleLogout = () => {
        sessionStorage.removeItem("authToken");
        sessionStorage.removeItem("userId")
        localStorage.removeItem("authToken")
        sessionStorage.removeItem("profileImageUrl")

        navigate("/"); // Redirect to login page
        window.location.reload();
    };
    const location = useLocation();

    const [showReplyComposer, setShowReplyComposer] = useState(
        false
    );
    useEffect(() => {
        if (location.state?.openComposer === true) {
            setShowReplyComposer(true);
        } else {
            setShowReplyComposer(false);
        }
    }, [location.state]);

    const stripHtmlPreserveLines = (html) => {
        if (!html) return "";

        return html
            .replace(/<br\s*\/?>/gi, "\n")
            .replace(/<\/p>/gi, "\n")
            .replace(/<\/div>/gi, "\n")
            .replace(/<\/li>/gi, "\n")
            .replace(/<[^>]+>/g, "")
            .trim();
    }; const adjustInternalHtml = (html) => {
        const container = document.createElement("div");
        container.innerHTML = html;
        return container.innerHTML;
    };
    const stripHtml = (html = "") => {
        const div = document.createElement("div");
        div.innerHTML = html;

        // convert <br> and <p> to line breaks
        div.querySelectorAll("br").forEach(br => br.replaceWith("\n"));
        div.querySelectorAll("p").forEach(p => {
            p.insertAdjacentText("afterend", "\n");
        });

        return div.textContent.trim();
    };

    const [showSideNav, setSideNav] = useState(false);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setSideNav(false); // close mobile sidebar
            }
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    const [checked, setChecked] = useState(false);


    const SIGNATURE_HTML = signature
        ? `<p data-signature="true" style="margin-top:16px;">${signature}</p>`
        : `<p><br/>${name} <br/>${emailsig} <br/>${phone}</p>`;




    const removeSignatureFromHtml = (html = "") => {
        if (!html) return "";

        const div = document.createElement("div");
        div.innerHTML = html;

        div.querySelectorAll('[data-signature="true"]').forEach(el => el.remove());

        return div.innerHTML.trim();
    };


    const handleCheckboxChange = (e) => {
        const isChecked = e.target.checked;
        setChecked(isChecked);

        setMessageBody(prev => {
            const cleaned = (prev);
            const result = isChecked
                ? prev + SIGNATURE_HTML
                : selectedTemplate1;
            return result;
            return isChecked
                ? cleaned + SIGNATURE_HTML
                : prev;
        });
    };
    const getProfileLink = (userId, memberType) => {
        const type = parseInt(memberType, 10);

        if (type === 3) {
            return `/contactProfile?userId=${userId}&memberType=${type}`;
        }

        if (type === 1 || type === 2) {
            return `/test?userId=${userId}&memberType=${type}`;
        }

        return "#";
    };


    const [open, setOpen] = useState(false);

    return (
        <div style={{ display: "flex", height: "100vh", overflowY: "auto" }}>
            <div className="hidden lg:block fixed w-[17%]"><Sidebar2 /></div>{showSideNav && <div><Sidebar2 /></div>}
            <div className="bg-gray-100 text-gray-800 min-h-screen font-sans" style={{ width: "100%" }}>
                <header className="bg-white shadow-sm flex items-center justify-between p-4 border-b">
                    <div className="flex items-center gap-2">
                        {/* MOBILE MENU BUTTON */}
                        <button
                            onClick={() => setSideNav(prev => !prev)}
                            className="lg:hidden p-2 rounded-md bg-gray-100 hover:bg-gray-200"
                        >
                            <IoMdMenu className="w-6 h-6 text-gray-700" />
                        </button>
                        <h1 className="text-2xl font-semibold text-gray-800 ml-4 lg:ml-0"></h1>
                    </div>

                    <div className="flex items-center space-x-4">
                        <div style={{ marginRight: "15px" }}><Link to="/"><FaHome size={28} /></Link></div>
                        <div className="relative">
                            <button className="flex items-center space-x-2" onClick={showDropDown}>
                                <img src={imagePreview} alt="User Avatar" className="h-10 w-10 rounded-full" />
                                <span className="hidden md:block">{name}</span>
                                <Icon name="chevron-down" className="w-4 h-4" />
                            </button>
                            {Heasderdropdown && <div className="dropDown3" >
                                <Link
                                    to="/dashboard"
                                    style={{ textDecoration: "none", color: "inherit" }}
                                >
                                    <div className="profileDrop">
                                        <div style={{ marginTop: "2px", marginRight: "6px" }}><IoPerson /></div>
                                        <div> <p>Dashboard</p></div>

                                    </div>
                                </Link>
                                <div className="dropLogout" onClick={handleLogout}>
                                    <div style={{ marginTop: "2px", marginRight: "6px" }}><IoLogOut /></div>
                                    <div>    <p>Logout</p></div>

                                </div>
                            </div>}
                        </div>
                    </div>
                </header>

                <div className=" p-4 md:p-8 ml-0 md:ml-[17%] w-full md:w-[83%]">
                    <div className="max-w-1xl mx-auto">
                        <div className="MessageIntroButt">
                            <div><h2 className='intoHeading' style={{ color: "#334e6f" }}><div dangerouslySetInnerHTML={{ __html: Heading }} /></h2>
                            </div>
                            <p className='IntroPara'>{stripHtml(subtitle)}</p>

                        </div>
                        <div className='bg-blue-600 hover:bg-blue-500 mb-4' style={{ padding: "8px 18px", color: "white", width: "70px", borderRadius: "15px" }} onClick={() => navigate(-1)}><TiArrowBack size={30} /></div>


                        {/* Single Column Layout (Reply Composer & History Stacked) */}
                        <div className="space-y-8">
                            {!showReplyComposer && (
                                <div className="flex justify-end mb-6">
                                    <button
                                        onClick={() => setShowReplyComposer(true)}
                                        className="px-8 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition duration-200 shadow-lg"
                                    >
                                        Reply
                                    </button>
                                </div>
                            )}

                            {/* Reply Composer (Full Width) */}
                            {showReplyComposer && (
                                <div className="bg-white p-6 rounded-xl message-box-shadow">

                                    {/* 1. Selectable Recipients (Checkboxes) */}
                                    <div className="" >
                                        <p className="text-sm font-medium text-gray-700 mb-2 flex"><div className='mt-[2px] mr-[5px]'><IoPersonOutline size={16} /></div> Select recipients (excluding yourself):</p>
                                        <div id="recipient-checkbox-container" className=" gap-x-6 gap-y-3 flex mb-4 mt-3 w-[100%] dwadtrow">
                                            {data.usersData?.map(recipient => (

                                                <div key={recipient.id} className={`border rounded-xl p-4 flex items-start gap-3 shadow-sm sm:w-[50%] w-[100%]emailtor break-all
    ${selectedRecipientEmails.includes(recipient.email)
                                                        ? "bg-[rgb(248,252,252)] border-[2px] border-[rgb(139,196,248)]"
                                                        : ""
                                                    }`}>
                                                    <input
                                                        id={`recipient-${recipient.id}`}
                                                        type="checkbox"
                                                        className="mt-1"
                                                        checked={selectedRecipientEmails.includes(recipient.email)}
                                                        onChange={(e) => {
                                                            const checked = e.target.checked;
                                                            setSelectedRecipientEmails(prev =>
                                                                checked
                                                                    ? [...prev, recipient.email]
                                                                    : prev.filter(email => email !== recipient.email)
                                                            );
                                                        }}
                                                    />

                                                    <label htmlFor={`recipient-${recipient.id}`} className="cursor-pointer mt-[-5px]">
                                                        <p className="font-semibold text-gray-800">{recipient.name}</p>
                                                        <p className="text-sm text-gray-500 flex">{recipient.email}</p>
                                                    </label>
                                                </div>
                                            ))}
                                        </div>

                                    </div>

                                    <div className='recpemail'>
                                        <label htmlFor="template-select" className="text-sm font-medium text-gray-700 w-full md:w-auto">Select Template:</label>
                                        <div className="flex flex-col md:flex-row md:items-center w-[100%] justify-between mb-4 space-y-3  awdawdttyu">

                                            <div className='awdttt'> <select
                                                id="template-select"
                                                value={selectedTemplate}
                                                onChange={handleTemplateChange}
                                                className="flex-grow w-[100%]  p-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition duration-150 ease-in-out"
                                            >
                                                <option value="">-- Select a template --</option>
                                                {template1.map(template => (
                                                    <option key={template.id} value={template.id}>
                                                        {template.template_name}

                                                    </option>
                                                ))}
                                            </select></div>
                                            <Link to="/emailTemplate" state={{ view: "add" }}> <button
                                                onClick={simulateCreateTemplate}
                                                className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-blue-700 transition duration-200 shadow-md whitespace-nowrap segerbutton"
                                            >
                                                + Create New Template
                                            </button></Link>
                                        </div>
                                    </div>

                                    {/* 2. Email Template Selection & Creation */}


                                    {/* 3. Message Body */}
                                    <div className='mt-4'><label>Message Content :</label></div>
                                    <div className="mb-6 mt-3 " style={{ borderTop: "1px solid black" }}>
                                        <ReactQuill
                                            theme="snow"
                                            value={messageBody}
                                            onChange={setMessageBody}
                                            className='awdfontp'
                                            modules={{ toolbar: false }}
                                        />

                                    </div>


                                    {/* 4. Include Signature Option */}
                                    <div className="flex items-center mt-3 mb-6">



                                    </div>

                                    {/* 5. Send and Cancel Buttons */}
                                    <div className="flex justify-between space-x-4 awdaflex">
                                        <div className="flex items-center mt-3 mb-6">
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                onChange={handleCheckboxChange}
                                            />
                                            <label
                                                htmlFor="include-signature"
                                                className="ml-2 text-sm flex  font-medium text-gray-700 cursor-pointer"
                                            >
                                                Include my signature   <div
                                                    className="iconWrapper1"
                                                    onMouseEnter={() => setShowad(true)}
                                                    onMouseLeave={() => setShowad(false)}
                                                >
                                                    <FaQuestionCircle style={{ marginLeft: "10px", cursor: "pointer" }} />

                                                    {showad && (
                                                        <div className='showad1'>
                                                            <div dangerouslySetInnerHTML={{ __html: key }}></div>
                                                        </div>
                                                    )}
                                                </div>
                                            </label>
                                        </div>
                                        <div className='w-[100%] sm:w-[60%] flex justify-between '>
                                            <button
                                                onClick={simulateCancel}
                                                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-xl font-semibold hover:bg-gray-100 transition duration-200 shadow-sm w-[45%]"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={handleSendReply}
                                                className="px-8 py-3 bg-blue-600 text-white rounded-xl font-semibold hover:bg-blue-700 transition duration-200 shadow-lg shadow-blue-200 w-[45%]"
                                            >
                                                Send
                                            </button></div>
                                    </div>

                                </div>)}

                            {/* 6. Previous Messages List (Full Width, Stacked Below) */}


                            <div className="bg-white p-6 rounded-xl message-box-shadow" style={{ overflowY: "auto", height: "500px" }}>
                                <h2 className="text-xl font-semibold text-gray-700 mb-4">Previous Messages</h2>
                                <div><h5>{subject}</h5></div>

                                {sentMail.map((details, index) => (<div id="MessagesContainer" key={details.id}>
                                    <div id="MessagesContainer1">
                                        <div className="w-[45px] h-[45px] flex-shrink-0 flex items-center justify-center bg-gray-400 text-white rounded-full text-xs font-bold">
                                            <img
                                                className="newimg1"
                                                src={
                                                    details.user_from?.image
                                                        ? `https://tracsdev.apttechsol.com/public/${details.user_from.image}`
                                                        : "https://tracsdev.apttechsol.com/public/uploads/user_avatar.jpeg"
                                                }
                                                alt="image"
                                            />
                                        </div>

                                        <div className="ml-2">
                                            <strong>
                                                <Link to={getProfileLink(details.user_id, details.user_from?.member_type || 3)}>
                                                    {details.user_from?.name || `${details.user_from_contact?.first_name} ${details.user_from_contact?.last_name}`}    </Link>
                                            </strong>
                                            <p className='ubtime'>
                                                {new Date(details.updated_at).toLocaleString("en-US", {
                                                    month: "short",
                                                    day: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                })}
                                            </p>
                                        </div>

                                    </div>
                                    <div id="MessagesContainer2">
                                        <div dangerouslySetInnerHTML={{ __html: adjustInternalHtml(details.body) }} ></div>
                                    </div>
                                </div>))}

                            </div>

                        </div>

                    </div>

                    {/* Custom Modal for Alerts */}
                    {showModal && (
                        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
                            <div className="bg-white p-6 rounded-xl shadow-2xl max-w-sm w-full">
                                <h3 className="text-lg font-semibold text-gray-800 mb-4">Notification</h3>
                                <p className="text-gray-600 mb-6">{modalMessage}</p>
                                <div className="flex justify-end">
                                    <button
                                        onClick={closeModal}
                                        className="px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition duration-200"
                                    >
                                        OK
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReplyMessage
